
export enum SANITIZER_TYPE {
  HTML,
  STYLE,
  SCRIPT,
  URL,
  URL_PREFIX,
  RESOURCE_URL
}

export enum ENVIRONMENT {
  PRODUCTION,
  STAGING,
  DEVELOPMENT,
  LOCAL
}

export enum UID_CODES {
  delfiJourneyVideo = 'delfiJourneyVideo',
  SlbHomePageTitle = 'SlbHomePageTitle',
  SlbHomePageDescription = 'SlbHomePageDescription',
  slbAgora = 'slbAgoraCardsComponent'
}

export const CART_DURATIONS  ={
  ONDEMAND: 'On Demand',
  FLEX: 'Flex'
}
export enum PRODUCT_CODE {
  BASE = 'BASE',
  PLUS = 'PLUS',
  THREEYEAR = 'THREEYEAR',
  ONEYEAR = 'ONEYEAR',
  ONDEMAND = 'ONDEMAND',
  FLEX = 'FLEX',
}

export const COUNTRY_CODE = {
  US_COUNTRY_ISO_CODE: "US",
	CA_COUNTRY_ISO_CODE: "CA",
	AU_COUNTRY_ISO_CODE: "AU",
	GB_COUNTRY_ISO_CODE: "GB",
}

export const DELFI_SOLUTIONS_CODE = {
  PTS: "PTS",
  PTS_OPTION: "PTS_OPTION",
  ODRS: "ODRS"
}

export const INITIAL_CONFIG = {
  SPA_DELFI_CLIENT_ID: 'SPA-DELFI-CLIENT-ID',
  SPA_URL_ENVIRONMENT: 'SPA-URL-ENVIRONMENT',
  SPA_AUTH_CLIENT_SECRET: 'SPA-AUTH-CLIENT-SECRET',
  SPA_URL_DELFI: 'SPA-URL-DELFI',
  SPA_TRAFFIC_MANAGER_APPCODE: 'SPA-TRAFFIC-MANAGER-APPCODE',
  SPA_AUTH_CLIENT_ID: 'SPA-AUTH-CLIENT-ID',
  SPA_CHIME_CLIENT: 'SPA-CHIME-CLIENT',
  SPA_API_URL: 'SPA-API-URL',
  PLP_PAGINATION_OPTIONS: 'PLP_PAGINATION_OPTIONS',
  SPA_AUTH_SCOPE: 'openid',
  SPA_AUTH_GRANT_TYPE: 'custom',
  SPA_AUTH_RESPONSE_TYPE: 'code token',
  SPA_AUTH_RESPONSE_TYPE_CODE: 'code',
  SPA_AUTH_RESPONSE_MODE: 'query',
  SPA_BASE_SITE: 'slb',
  SPA_BASE_URL: 'SPA_BASE_URL',
  NEXT_PAGE_URL: 'NEXT_PAGE_URL',
  EMARSYS_MERCHANT_ID: "EMARSYS_MERCHANT_ID",
  GOOGLE_ANALYTICS_ID: "GOOGLE_ANALYTICS_TRACKING_ID",
  COOKIEPRO_SCRIPT_DOMAIN: "COOKIEPRO-SCRIPT-DOMAIN",
  GOOGLE_TAG_MANAGER_ID: "GOOGLE_TAG_MANAGER_ID",
  SECOND_GOOGLE_TAG_MANAGER_ID: "SECOND_GOOGLE_TAG_MANAGER_ID",
  SMARTEDIT_ALLOW_ORIGIN: "SMARTEDIT_ALLOW_ORIGIN",
  SPA_ALLOWED_WEBSITES:"SPA-ALLOWED-WEBSITES",
  THEME: "theme",
  RELATED_EXTENSIONS_MAX_PAGE_SIZE: "RELATED_EXTENSIONS_MAX_PAGE_SIZE",
  JPM_DHPP_CHECKOUTID_URL: "JPM_DHPP_CHECKOUTID_URL"
}

export const CART_TYPES = {
  DELFI: "DELFI",
  AGORA: "AGORA",
  NEXT: "NEXT",
  SERVICE: "SERVICE",
  OCEAN: "OCEAN",
  SUBSCRIPTION: "SUBSCRIPTION"
}

export const STEP_STATUS =  {
  ACTIVE: "ACTIVE",
  COMPLETE: "COMPLETE",
  MISSED: "MISSED"
}

export const STEPS_ID = {
  QUOTE_PAGE: "QUOTE_PAGE",
  PROFILE_SELECTION_PAGE: "PROFILE_SELECTION_PAGE",
  SIMULATION_ESTIMATIONS_PAGE: "SIMULATION_ESTIMATIONS_PAGE",
  STORAGE_AND_ELASTIC_CAPACITY_PAGE: "STORAGE_AND_ELASTIC_CAPACITY_PAGE",
  SUMMARY_PAGE: "SUMMARY_PAGE",
  DELFI_READINESS_PAGE: "DELFI_READINESS_PAGE",
  SHIPPING_AND_BILLING_PAGE: "SHIPPING_AND_BILLING_PAGE",
  PAYMENT_PAGE: "PAYMENT_PAGE",
  ORDER_REVIEW_PAGE: "ORDER_REVIEW_PAGE",
  LICENSE_HARDWARE_PAGE: "LICENSE_HARDWARE_PAGE",
  ORDER_DETAILS_PAGE: "ORDER_DETAILS_PAGE",
  ORBITAL_PAYMENT_PAGE: "ORBITAL_PAYMENT_PAGE"
}

export const PAYMENT_STEPS_ID = {
  INVOICE_DETAILS_PAGE: "INVOICE_DETAILS_PAGE",
  PAYMENT_INFORMATION_PAGE: "PAYMENT_INFORMATION_PAGE",
  REVIEW_SUBMIT_PAYMENT_PAGE: "REVIEW_SUBMIT_PAYMENT_PAGE",
  LANDING_PAGE: "LANDING_PAGE"
}


export const ALERT_MESSAGES = {
  CART: {
    NOT_FULLY_ONBOARDED: `cart.alert.notFullyOnboarded`,
    NOT_SUPPORT_COUNTRY_NEXT_CART: `cart.alert.notSupportCountryNextCart`,
    NOT_SUPPORT_COUNTRY_CART: `cart.alert.notSupportCountryCart`,
    DOWN_JONES_FLAGGED: `cart.alert.dowJonesFlagged`,
    NOT_BUY_OPTION: 'cart.alert.notBuyOption',
    NEXT_CLASS_EXPIRED: 'cart.alert.nextClassExpired',
    HAS_NOT_LISTED_PRODUCTS: 'cart.alert.hasNotListedProducts'
  }
}

export const ADD_TO_CART_POPUP_TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
}

export const EDGE_SOLUTIONS_RB_VALUES = {
  included: 'included',
  doNotinclided: 'Do not include'
}

export const EDGE_SOLUTIONS_PRODUCT_CODES = {
  AGORA_GATEWAY_PRODUCT_CODE: 'AGRPRD-BASE',
  AGORA_SALE: 'AGRPRD-SALE',
  GATEWAY_INSTALLATION_CODE: 'AGRINS-PJ-SVC',
  DATA_EXPLORER_CODE: 'AGRDEX-SV-SVC'
}

export const MIXED_CART_ERROR = 'mixedcarterror';
export const MIXED_CART_LICENSE_ERROR = 'mixedcartlicenseerror';
export const CART_HAS_NOT_LISTED_PRODUCTS = 'forbiddenProductVisibility';

export const URL_PARAMS = {
  CODE: 'code',
  PAGE_TYPE: 'pageType',
  PAGE_LABEL_OR_ID: 'pageLabelOrId'
};

export const PAGE_TYPES = {
  CATEGORY_PAGE: 'CategoryPage',
  SEARCH_PAGE: 'search',
  CONTENT_PAGE: 'ContentPage',
  PRODUCT_PAGE: 'ProductPage'
}

export type HEADER_TYPES = 'CLOUD_SOLUTIONS' | 'EDGE_SOLUTIONS' | 'OCEAN' | 'SERVICES' | 'VIDEO_LIBRARY' | 'PLUGIN_AND_EXTENSIONS' | 'REFERRAL' | 'SUBSCRIPTIONS';

export const HEADER_PAGES_ID = {
  CLOUD_SOLUTIONS: ['productsListPage', 'profileDetailsPage', 'slbProfileDetailsPage'],
  SUBSCRIPTIONS: ['slbSubscriptionDetailsPage', 'subscriptionVariantDetailsPage', 'subscriptionsCategoryPage', 'workflowDetailsPage', 'applicationDetailsPage'],
  EDGE_SOLUTIONS: ['productsListAgoraPage', 'slbProductDetails'],
  OCEAN: ['slbOceanProductGridPage', 'slbOceanCategoryPage', 'slbOceanProductDetails'],
  SERVICES: ['slbCategoryPage', 'slbProductGridPage', 'slbServiceProductDetails'],
  VIDEO_LIBRARY: ['videoLibraryPage', 'playVideo1Page', 'playVideo2Page', 'playVideo3Page', 'playVideo4Page', 'playVideo5Page', 'playVideo6Page', 'playVideo7Page', 'playVideo8Page', 'playVideo9Page', 'playVideo10Page', 'playVideo11Page'],
  PLUGIN_AND_EXTENSIONS: ['pluginsAndExtensionsPage', 'slbPluginsAndExtensionsProductDetails'],
  REFERRAL: []
}

export const HEADERS_UIDS = {
  CLOUD_SOLUTIONS: 'SlbCloudSolutionsHeaderLink',
  SUBSCRIPTIONS: 'SlbSubscriptionsHeaderLink',
  EDGE_SOLUTIONS: 'SlbEdgeSolutionsHeaderLink',
  OCEAN: 'SlbOceanHeaderLink',
  SERVICES: 'SlbServiceHeaderLink',
  VIDEO_LIBRARY: 'SlbVideoLibraryHeaderLink',
  PLUGIN_AND_EXTENSIONS: 'SlbOceanHeaderLink',
  REFERRAL: 'SlbReferralsHeaderLink'
}

export const SHIPMENT_RESTRICTIONS = {
  MAX_FIELD_LENGTH: 35,
	CITY_MAX_FIELD_LENGTH: 30,
	ADDRESS_MAX_FIELD_LENGTH: 50,
	MAX_POSTCODE_LENGTH: 9,
	MAX_POSTCODE_FIVE_LENGTH: 5,
	MAX_POSTCODE_CANADA_LENGHT: 7,
	MAX_POSTCODE_GB_LENGTH: 8,
	MAX_PHONE_NUMBER_LENGTH: 10,
	MIN_PHONE_NUMBER_LENGTH: 7,
}

export const SERVICES_DEFAULT_QUERY = ':relevance:allCategories:';
export const SERVICES_SEARCH = 'searchServices';
export const OCEAN_SEARCH = 'searchOcean';


export const SOLUTIONS_URL: {[key:string]: string} = {
  SUBSCRIPTION: 'c/subscriptions',
  DELFI: 'cloudsolutions',
  AGORA: 'edgesolutions',
  SERVICE: 'Consulting-Services',
  OCEAN: 'Ocean-Store/Plug-ins/c/plugin',
  OCEAN_SOLUTIONS: 'oceansolutions',
  NEXT: ''
}

export const OCEAN_DOMAIN: { [key: string]: string } = {
  GEOLOGYMODELLING: 'Geology & Modelling',
  GEOPHYSICS: 'Geophysics',
  RESERVOIRENGINEERING: 'Reservoir Enginnering',
  RESERVOIRGEOMECHANICS: 'Reservoir Geomechanics',
  DRILLING: 'Drilling',
  INFORMATIONMANAGEMENT: 'Information Management',
  FLOWASSURANCE: 'Flow Assurance',
  PROCESSSAFETY: 'Process Safety'

}

export const OCEAN_CHALLENGES: { [key: string]: string } = {
  DEEPWATEREXPLORATIONANDPRODUCTION: 'Deepwater Exploration and Production',
  UNCONVSHALE: 'Unconv.-Shale',
  UNCONVHEAVYOIL: 'Unconv.-Heavy Oil',
  UNCONVTIGHTGASANDOIL: 'Unconv.–Tight Gas & Oil',
  UNCONVCOALBEDMETHANE: 'Unconv.–Coalbed Methane',
  ENHANCEDOILRECOVERY: 'Enhanced Oil Recovery',
  CARBONATEANDFRACTURES: 'Carbonate and Fractures',
  REALTIMEOPERATIONS: 'Real-Time Operations'
}

export const CUSTOMER_TYPES = {
  CREDITCARD: 'CREDITCARD',
  PURCHASEORDER: 'PURCHASEORDER',
  ISVCUSTOMER: 'ISVCUSTOMER'
}

export const LICENSES_TYPES = [
  {
    id: "Purchase",
    label: "Sale"
  },
  {
    id: "Rental",
    label: "Rental"
  },
  {
    id: "Evaluation",
    label: "Evaluation"
  },
  {
    id: "Academic",
    label: "University"
  },
  {
    id: "Development",
    label: "Development"
  }
]

export const ORDER_STATUS = {
  APPROVED_BY_MERCHANT: 'Processing Order',
  SENT_SEACOLT: 'Processing order',
  COMPLETED: 'Completed',
  PENDING_APPROVAL: 'Pending Approval',
  PENDING_ORDER_REVIEW: 'Pending Order Review',
  REJECTED: 'Cancelled',
  CANCELLED: 'Cancelled',
  PAYMENT_CAPTURE_FAILURE: 'Processing Order',
  SUSPENDED: 'Suspended',
  TERMINATED: 'Terminated',
  TERMINATED_FINALIZED: 'Terminated',
  ACTIVE: 'Active',
  DELFI_CONTRACT_CREATED_IN_PORTAL: "Delfi contract created in portal",
  DEPLOYMENT_SPECS_COMPLETED: "Deployment Specifications completed",
  DEPLOYMENT_STARTED: "Deployment Started",
  DEPLOYMENT_READY_FOR_VALIDATION: "Deployment ready for validation",
  VALIDATION_STARTED: "Deployment validation started",
  READY_FOR_ONBOARDING: "Customer ready for onboarding",
  CUSTOMER_ONBOARDED: "Customer onboarded",
  APPROVED: 'Processing Order',
  CANCELLING: 'Cancel Pending',
  ERROR: 'Pending',
  OPEN: 'Open',
  PROCESSING: 'In process',
  CREATED: 'Processing Order',
  EMPTY: ""
}

export const ORDER_HISTORY_PAGINATION = [
  {
    id: '50',
    label: 'pagination.itemsPerPage'
  },
  {
    id: '100',
    label: 'pagination.itemsPerPage'
  },
  {
    id: '150',
    label: 'pagination.itemsPerPage'
  },
]

export const GOOGLE_TAG_MANAGER_ACTIONS = {
  ON_LOAD: 'onLoad',
  PROFILE_SELECTED: 'Profile Selected ',
  CONTRACT_TERMS_SELECTED: 'Contract Terms Selected ',
  PRODUCT_PRICE_CHANGED: 'Product price has changed to: ',
  LICENSE_TYPE_SELECTED: 'License type selected: ',
  PURPOSE_SELECTED: 'Purpose selected: ',
  RENTAL_MONTHS_CHANGED: 'Change the rental months for:',
  QUANTITY_CHANGED: 'Change the quantity by '
}

export const FACET_VALUES: {[key: string]: string} = {
  "petrel": "Petrel",
  "studiomanager": "Studio",
  "aiworkspace": "AI Workspace",
  "drillplan": "DrillPlan",
  "fdplan": "FDPlan",
  "techlog": "Techlog",
  "prosource": "ProSource",
  "merak": "Merak",
  "petromod": "PetroMod",
  "eclipse": "ECLIPSE",
  "geologyModelling": "Geology & modeling",
  "geophysics": "Geophysics",
  "reservoirEngineering": "Reservoir Engineering",
  "reservoirGeomechanics": "Reservoir Geomechanics",
  "drilling": "Drilling",
  "informationManagement": "Information management",
  "flowAssurance": "Flow assurance",
  "processSafety": "Process safety",
  "ReservoirCharacterizationConsulting": "Consulting",
  "ReservoirAnalysis": "Reservoir analysis",
  "DataScience": "Data Science",
  "SeismicLogEditing": "Seismic log editing",
  "SeismicWellTie": "Seismic well tie",
  "SeismicInversion": "Seismic inversion",
  "SeismicAttributes": "Seismic attributes",
  "WellPlanning": "Well planning",
  "Interpretation": "Interpretation",
  "ReservoirFluid": "Reservoir fluid",
  "ReservoirCharacterization": "Reservoir characterization",
  "ReservoirPerformance": "Reservoir performance",
  "Services": "Consulting Services",
  "WaterServices": "Water Services",
  "ReservoirPerformanceConsulting": "Consulting"
}

export const FACET_VALUES_2: {[key: string]: string} = {
  "petrel": "Petrel XD",
  "studiomanager": "Studio",
  "techlog": "Techlog XD",
  "prosource": "ProSource",
  "merak": "Merak",
  "petromod": "PetroMod",
  "eclipse": "ECLIPSE",
  "geologyModelling": "Geology & modeling",
  "geophysics": "Geophysics",
  "reservoirEngineering": "Reservoir Engineering",
  "reservoirGeomechanics": "Reservoir Geomechanics",
  "drilling": "Drilling",
  "informationManagement": "Information management",
  "flowAssurance": "Flow assurance",
  "processSafety": "Process safety",
  "ReservoirCharacterizationConsulting": "Consulting",
  "ReservoirAnalysis": "Reservoir analysis",
  "DataScience": "Data Science",
  "SeismicLogEditing": "Seismic log editing",
  "SeismicWellTie": "Seismic well tie",
  "SeismicInversion": "Seismic inversion",
  "SeismicAttributes": "Seismic attributes",
  "WellPlanning": "Well planning",
  "Interpretation": "Interpretation",
  "ReservoirFluid": "Reservoir fluid",
  "ReservoirCharacterization": "Reservoir characterization",
  "ReservoirPerformance": "Reservoir performance",
  "Services": "Consulting Services",
  "WaterServices": "Water Services",
  "ReservoirPerformanceConsulting": "Consulting",
  "petrel xd": "Petrel XD",
  "techlog xd": "Techlog XD",
  "Petrel xd": "Petrel XD",
  "Techlog xd": "Techlog XD",
  "Petrel": "Petrel XD",
  "Techlog": "Techlog XD"
}

export const QUOTE_STATUS = {
  OFFER: "slb.quote.status.offer",
  CANCELLED: "slb.quote.status.cancelled",
  REPLACED: "slb.quote.status.replaced",
  EXPIRED: "slb.quote.status.expired",
  BUYER_ACCEPTED: "slb.quote.status.buyer_accepted",
}

export const SESSION_UID = 'isLoginOrRegistered';

export const PLATFORM_TYPE = {
  petrel: 'Petrel XD',
  techlog: 'Techlog XD',
  studiomanager: 'Studiomanager',
  prosource: 'Prosource',
  merak: 'Merak',
  petromod: 'Petromod',
  eclipse: 'Eclipse'
}

export const ApplicationFilter = {
  "name" : "Apps",
  "query" : {
      "query" : {
        "value" : "applications"
      },
  },
  "selected" : false
}

export const ModulesFilter = {
    "name" : "Modules",
    "query" : {
        "query" : {
          "value" : "modules"
        },
    },
    "selected" : false
}

export const PluginsFilter = {
    "name" : "Plugins",
    "query" : {
        "query" : {
          "value" : "plugins"
        },
    },
    "selected" : false
}
